import NotFoundScreen from './components/NotFoundScreen'

export default {
  path: '/404',
  name: 'NotFound',
  component: NotFoundScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/NotFound/index.js